import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';

class ScrollItem__Projects extends Scroll_Item {
    _call;
    _callOut;
    _visor;
    _current = -1;
    _currentImage = -1;
    _total = 0;
    _items = [];
    _sizes = {
        width:0,
        height:0
    }

    get current() { return this._current; }
    set current(__current) {
      this._current = __current;
      this.item.style.setProperty('--current', `${this._current}`);
    }

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._visor = GetBy.class("__visor", this.item)[0];
        this._figure = GetBy.class("__figure", this.item)[0];

        
            
            this.setupVisor();
            this.updateSizes();
        
            this.onMove = () => {
                this.showProgress();
            };

            this._call = (e) => this.hover(e);
            this._callOut = (e) => this.out(e);
            
            this.resize();
            this.showNext(0);
            this.showNextImage(0);

            document.addEventListener(Basics.moveEvent, this._call);
            document.addEventListener(Basics.mouseOut, this._callOut);
        
    }

    showProgress() {
        const next = Math.floor(this._total * this.progressInside);
        
        this.showNext(next);
        this.showNextImage(next);
    }

    showNext(next) {
        
        if(this._current == next)  return;
        if(next >= this._total) return;

        if(this._current >= 0) {
            this._items[this._current].link.classList.remove("--show");
        }

        this._items[next].link.classList.add ("--show");
        this.current = next;
    }

    showNextImage(next) {
        if(this._currentImage == next)  return;
        if(next >= this._total) return;

        if(this._currentImage >= 0) {
            this._items[this._currentImage].image.classList.remove("--show");
        }

        this._items[next].image.classList.add ("--show");
        this._currentImage = next;
        
        this._figure.style.setProperty('--scale-x', `${this._items[next].scaleX}`);
        this._figure.style.setProperty('--scale-y', `${this._items[next].scaleY}`);

        this._visor.href = this._items[next].url;

      /*  if(this._currentImage == 0) {
            this._figure.style.setProperty('--x', `1`);
            this._figure.style.setProperty('--y', `0`);
        } else if(this._currentImage == this._total - 1) { 
            this._figure.style.setProperty('--x', `0.5`);
            this._figure.style.setProperty('--y', `1`);
        } else {
            this._figure.style.setProperty('--x', `${Math.random()}`);
            this._figure.style.setProperty('--y', `${Math.random()}`);
        }*/
        

    }


    setupVisor() {
        const items = [... GetBy.selector("img", this.item)];
        const links = [... GetBy.class("__link", this.item)];

        for(let i=0; i<items.length; i++) {
            links[i].setAttribute("data-image", i);

            this._total = this._items.push({
                image: items[i],
                link: links[i],
                url: links[i].href,
                scaleX: 1,
                scaleY: 1,
            });
        }
    }

    updateSizes() {  
        
        if(this._total <= 0) return;

        const rect = this._visor.getBoundingClientRect();

        this._sizes = {
            width: rect.width,
            height: rect.height
        }

        for(let i=0; i<this._total; i++) {
            const image = this._items[i].image;
            const w = Number(image.getAttribute("width"));
            const h = Number(image.getAttribute("height"));
            let scaleX = w / this._sizes.width;
            let scaleY = h / this._sizes.height;

            if(scaleX > scaleY) {
                scaleY = scaleY / scaleX;
                scaleX = 1;
            }

            if(scaleY > scaleX) {
                scaleX = scaleX / scaleY;
                scaleY = 1;
            }

            // Si alguno es mayor que 1, igualamos ese a 1 y ajustamos el otro proporcionalmente
           /* if (scaleX > 1) {
                scaleY = scaleY / scaleX;
                scaleX = 1;
            }

            if (scaleY > 1) {
                scaleX = scaleX / scaleY;
                scaleY = 1;
            }*/

            this._items[i].scaleX = scaleX;
            this._items[i].scaleY = scaleY;
        }
    }

    hover(e) {
        switch (e.target.tagName.toLowerCase()) {
            case "a":
            //NOT ANCHOR
            const n = e.target.getAttribute("data-image");
            if (n) {
                this.showNextImage(Number(n));
            }

            break;
        }
    }

    out(e) {
        this.showProgress();
    }

    resize(w, h) {
        super.resize(w, h);
        this.updateSizes();
    }

    loop() {}

    dispose() {
        super.dispose();
        document.removeEventListener(Basics.moveEvent, this._call);
    }
}

Scroll._registerClass('Projects', ScrollItem__Projects);
